import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useGetDocuments() {
  const { data, isLoading } = useQuery(
    ["DOCUMENTS"],
    () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/application/document`)
        .then((response) => {
          return response.data;
        }),
    {
      refetchOnWindowFocus: false,
    }
  );

  return {
    loading: isLoading,
    documentsData: data?.data,
  };
}

export function useCheckDocuments() {
  const { data, isLoading } = useQuery(
    ["CHECK-DOCUMENTS"],
    () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/application/check-document`)
        .then((response) => {
          return response.data;
        }),
    {
      refetchOnWindowFocus: false,
    }
  );

  return {
    loading: isLoading,
    documentsCheckData: data?.data,
  };
}
